export default __webpack_public_path__ + "static/media/aestheticdermal_form.3b2cdae3.png";